import { statusColor } from "./microbleedStatus";
import type { MicrobleedStatus } from "./useMicrobleeds";

const ENTRIES: { status: MicrobleedStatus; label: string }[] = [
  { status: "new", label: "New" },
  { status: "stable", label: "Stable" },
  { status: "not_observed", label: "Not observed" },
];

function MicrobleedLegend() {
  return (
    <div className="flex gap-4 px-2 py-2 text-xs text-stone-300">
      {ENTRIES.map(({ status, label }) => {
        const [r, g, b] = statusColor(status);
        return (
          <div key={status} className="flex items-center gap-1">
            <span
              className="inline-block w-3 h-3 rounded-sm"
              style={{ backgroundColor: `rgb(${r},${g},${b})` }}
            />
            <span>{label}</span>
          </div>
        );
      })}
    </div>
  );
}

export default MicrobleedLegend;
